import { sendPost } from '../http.js'
const api = {
	'addAccount': '/login/login/add/account',
    'permission': '/login/login/permission',
    'accountList': '/login/login/account/list',
    'menuList': '/login/login/menu',
    'accountInfo': '/login/login/account/info',
    'editAccount':'/login/login/edit/account',
    'editPermission':'/login/login/edit/account/permission',
    'enableAccount': '/login/login/enable/account',
	'accountDel': '/login/login/account/del'
}

export default {
	addAccount(params) {
		return sendPost(api.addAccount, params)
	},
    permission(params) {
		return sendPost(api.permission, params)
	},
    accountList(params) {
		return sendPost(api.accountList, params)
	},
    menuList(params) {
		return sendPost(api.menuList, params)
	},
    accountInfo(params) {
		return sendPost(api.accountInfo, params)
	},
    editAccount(params) {
		return sendPost(api.editAccount, params)
	},
    editPermission(params) {
		return sendPost(api.editPermission, params)
	},
    enableAccount(params) {
		return sendPost(api.enableAccount, params)
	},
	accountDel(params) {
		return sendPost(api.accountDel, params)
	},
}
